"use client";
import { useSession } from "next-auth/react";

import { useState } from "react";
import { ProfileDropdown } from "./ProfileDropdown";

import { AuthNav } from "./AuthNav";
import { AuthUser } from "./AuthUser";
import { Logo } from "./Logo";
import { BlogHeader } from "./BlogHeader";

export function BlogNav() {
  const { data: session, status } = useSession();
  const [dropDownIsOpen, setDropDownIsOpen] = useState(false);

  function toggleDropDown() {
    setDropDownIsOpen((dropDownIsOpen) => !dropDownIsOpen);
  }

  return (
    <nav
      className={`justify-between flex bg-[#2d5ad0] text-white items-center flex-row md:gap-12 px-5 sm:px-10 md:px-16 lg:px-24 py-5 shadow-md sticky top-0 z-50`}
    >
      <BlogHeader>
        <Logo />

        {session && status === "authenticated" ? (
          <AuthUser />
        ) : (
          <AuthNav />
        )}
        {dropDownIsOpen ? <ProfileDropdown /> : null}
      </BlogHeader>
    </nav>
  );
}
